module.exports = __webpack_public_path__ + "img/head-tip.e546591.svg";